// Menú lateral del negocio: 7 grupos por lo que hace el dueño (decisión del 2026-10-06). Solo agrupa y nombra: las rutas y las páginas son las mismas.
// `module` es el interruptor por negocio. `hidden: true` = el ítem no aparece con el módulo apagado (módulos en prueba);
// sin `hidden`, aparece con un candado para que el dueño sepa que existe y requiere activarlo.
// `match` lista las rutas que dejan el ítem marcado como activo; `prefix` hace que también cuente lo que cuelga de la ruta (/v2/ventas/12).

// Un color por grupo para distinguirlos de un vistazo (título, íconos, línea lateral y ítem activo). Las clases van completas
// porque Tailwind solo genera las que lee escritas en el código.
export const GROUP_COLORS = {
  emerald: { title: 'text-emerald-400', icon: 'text-emerald-400', line: 'border-emerald-500/40', active: 'bg-emerald-500/10 text-emerald-300 border border-emerald-500/40 font-bold', hover: 'hover:bg-emerald-500/5 hover:text-emerald-200' },
  sky: { title: 'text-sky-400', icon: 'text-sky-400', line: 'border-sky-500/40', active: 'bg-sky-500/10 text-sky-300 border border-sky-500/40 font-bold', hover: 'hover:bg-sky-500/5 hover:text-sky-200' },
  violet: { title: 'text-violet-400', icon: 'text-violet-400', line: 'border-violet-500/40', active: 'bg-violet-500/10 text-violet-300 border border-violet-500/40 font-bold', hover: 'hover:bg-violet-500/5 hover:text-violet-200' },
  amber: { title: 'text-amber-400', icon: 'text-amber-400', line: 'border-amber-500/40', active: 'bg-amber-500/10 text-amber-300 border border-amber-500/40 font-bold', hover: 'hover:bg-amber-500/5 hover:text-amber-200' },
  rose: { title: 'text-rose-400', icon: 'text-rose-400', line: 'border-rose-500/40', active: 'bg-rose-500/10 text-rose-300 border border-rose-500/40 font-bold', hover: 'hover:bg-rose-500/5 hover:text-rose-200' },
  fuchsia: { title: 'text-fuchsia-400', icon: 'text-fuchsia-400', line: 'border-fuchsia-500/40', active: 'bg-fuchsia-500/10 text-fuchsia-300 border border-fuchsia-500/40 font-bold', hover: 'hover:bg-fuchsia-500/5 hover:text-fuchsia-200' },
  green: { title: 'text-seryi-green', icon: 'text-seryi-green', line: 'border-seryi-green/40', active: 'bg-seryi-green/10 text-seryi-green border border-seryi-green/30 font-bold', hover: 'hover:bg-seryi-bg-light/50 hover:text-seryi-heading' }
};

export const MENU_GROUPS = [
  {
    id: 'inicio', label: null, color: 'green', items: [
      { to: '/v2/dashboard', label: 'Consola Local', icon: 'LayoutDashboard' }
    ]
  },
  {
    id: 'vender', label: 'Vender', emoji: '🛒', color: 'emerald', items: [
      { to: '/v2/pedidos', label: 'Pedidos', icon: 'Store', module: 'feature_orders' },
      { to: '/v2/cotizaciones', label: 'Cotizaciones', icon: 'FileText', module: 'feature_cotizaciones', hidden: true, prefix: true },
      { to: '/v2/ventas', label: 'Ventas y cartera', icon: 'Receipt', module: 'feature_cotizaciones', hidden: true, prefix: true }
    ]
  },
  {
    id: 'clientes', label: 'Clientes', emoji: '👥', color: 'sky', items: [
      { to: '/v2/clientes', label: 'Clientes', icon: 'Contact' },
      { to: '/v2/crm', label: 'CRM Kanban', icon: 'LayoutDashboard', module: 'feature_appointments' },
      { to: '/v2/seguimiento', label: 'Seguimiento automático', icon: 'Send', module: 'feature_seguimiento' },
      { to: '/v2/marketing', label: 'Campañas y difusión', icon: 'Megaphone', module: 'feature_campaigns' },
      { to: '/v2/contenido', label: 'Contenido con IA', icon: 'Sparkles', module: 'feature_contenido' },
      { to: '/v2/competencia', label: 'Análisis de competencia', icon: 'BarChart2', module: 'feature_reportes' },
      { to: '/v2/anuncios', label: 'Anuncios en Meta', icon: 'Target', module: 'feature_ads' },
      { to: '/v2/fidelizacion', label: 'Fidelización', icon: 'CreditCard', module: 'feature_loyalty' },
      { to: '/v2/prospeccion', label: 'Prospección Maps', icon: 'MapPin', module: 'feature_prospecting', hidden: true }
    ]
  },
  {
    id: 'agenda', label: 'Agenda y equipo', emoji: '📅', color: 'violet', items: [
      { to: '/v2/agenda', label: 'Agenda Inteligente', icon: 'Calendar', module: 'feature_appointments' },
      { to: '/v2/staff', label: 'Equipo y staff', icon: 'Users', module: 'feature_staff' },
      { to: '/v2/comisiones', label: 'Comisiones', icon: 'DollarSign', module: 'feature_commissions' }
    ]
  },
  {
    id: 'productos', label: 'Productos', emoji: '📦', color: 'amber', items: [
      // Un solo ítem: el catálogo de servicios o menú y, dentro, las listas de precios (pestañas, ver ProductsTabs).
      { to: '/v2/servicios', label: 'Catálogo y precios', labelRestaurant: 'Menú y precios', icon: 'DollarSign', module: 'feature_services', match: ['/v2/servicios', '/v2/catalogo'] },
      { to: '/v2/inventario', label: 'Inventario y stock', icon: 'Package', module: 'feature_inventory' }
    ]
  },
  {
    id: 'contabilidad', label: 'Contabilidad', emoji: '💰', color: 'rose', items: [
      { to: '/v2/cierre', label: 'Cierre del día', icon: 'Receipt', module: 'feature_finanzas' },
      { to: '/v2/caja', label: 'Caja y resultado', icon: 'Landmark', module: 'feature_finanzas' },
      { to: '/v2/gastos', label: 'Gastos y por pagar', icon: 'Wallet', module: 'feature_finanzas' },
      { to: '/v2/finances', label: 'Finanzas y reportes', icon: 'BarChart2', module: 'feature_finanzas' },
      { to: '/v2/reporte-semanal', label: 'Reporte semanal', icon: 'CalendarCheck', module: 'feature_reportes' }
    ]
  },
  {
    id: 'bot', label: 'Bot y sitio', emoji: '🤖', color: 'fuchsia', items: [
      { to: '/v2/config', label: 'Bot y configuración', icon: 'MessageSquare' },
      { to: '/v2/preguntas-bot', label: 'Preguntas del bot', icon: 'HelpCircle', module: 'feature_bot_aprende' },
      { to: '/v2/menu-media', label: 'Carta o menú para el bot', icon: 'Package', module: 'feature_menu_media' },
      { to: '/v2/minisitio', label: 'Sitio web', icon: 'Store' },
      { to: '/v2/academy', label: 'Seryi Academy', icon: 'Users' }
    ]
  }
];

// Menú que ve este negocio: sin los ítems ocultos por módulo apagado, con `locked` en los que requieren activar un módulo y sin grupos vacíos.
// `isEnabled(moduleKey)` dice si el módulo está encendido.
export const buildMenu = (isEnabled, { isRestaurant = false } = {}) =>
  MENU_GROUPS.map((group) => ({
    ...group,
    items: group.items
      .filter((item) => !(item.hidden && item.module && !isEnabled(item.module)))
      .map((item) => ({
        ...item,
        label: isRestaurant && item.labelRestaurant ? item.labelRestaurant : item.label,
        locked: Boolean(item.module) && !item.hidden && !isEnabled(item.module)
      }))
  })).filter((group) => group.items.length > 0);

// ¿Está activo este ítem con la ruta actual?
export const isItemActive = (item, path) => {
  const routes = item.match || [item.to];
  return routes.some((r) => path === r || (item.prefix && path.startsWith(`${r}/`)));
};
